
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"#D8F3DC"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.833 6.413a1 1 0 00-1.42 0l-2.29 2.3-2.29-2.3a1.004 1.004 0 00-1.42 1.42l2.3 2.29-2.3 2.29a.999.999 0 000 1.42 1.001 1.001 0 001.42 0l2.29-2.3 2.29 2.3a1 1 0 001.42 0 1.002 1.002 0 000-1.42l-2.3-2.29 2.3-2.29a1 1 0 000-1.42zm3.36-3.36a10 10 0 10-14.14 14.14 10 10 0 1014.14-14.14zm-1.41 12.73a8 8 0 112.34-5.66 7.949 7.949 0 01-2.34 5.66z"}})])
          )
        }
      }
    